export default __webpack_public_path__ + "static/media/pet-bottle-bales.58ba46ea.jpg";